module.exports = __webpack_public_path__ + "static/roof_night_mobile-18a2c76f97e7c295f04dbb2d8db85ae9.jpg";